












import { DatePickerOptions } from "element-ui/types/date-picker";
import { Component, Vue, Prop } from "vue-property-decorator";
const today = new Date();

@Component
export default class ThDatePicker extends Vue {
    @Prop({
        type: String,
        default: ""
    })
    text!: string;

    @Prop({
        type: String,
        default: "yyyyMMdd"
    })
    valueFormat!: string;

    @Prop({
        type: [String, Array],
        default: ""
    })
    date!: string | string[];

    dateCopy = this.date;

    @Prop({
        type: String,
        default: "date"
    })
    dateType!: string;

    @Prop({
        type: String,
        default: () => Vue.utils.simpleDateFormat(new Date(), "d", true)
    })
    defaultDate!: string;
    defaultDateVal = new Date(this.defaultDate);

    @Prop({
        type: Array,
        default: () => ["1970-01-01", "2100-01-01"]
    })
    dateRange!: string[];

    pickerOptions: DatePickerOptions = {
        disabledDate: date => {
            return date < new Date(this.dateRange[0]) || date > new Date(this.dateRange[1]);
        },
        shortcuts: this.valueFormat.includes("dd") ? [
            {
                text: "今天",
                onClick(picker) {
                    picker.$emit("pick", Vue.utils.simpleDateFormat(new Date(), "d"));
                }
            },
            {
                text: "昨天",
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(date, "d"));
                }
            },
            {
                text: "一周前",
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(date, "d"));
                }
            },
            {
                text: "本月月初",
                onClick(picker) {
                    const date = new Date();
                    const first = new Date(date.getFullYear(), date.getMonth(), 1);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(first, "d"));
                }
            },
            {
                text: "本月月末",
                onClick(picker) {
                    const date = new Date();
                    const last = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                    const lastDay = Vue.utils.dateAdd(last, "d", -1);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(lastDay, "d"));
                }
            },
            {
                text: "清空",
                onClick(picker) {
                    picker.$emit("pick", "");
                }
            }
        ] : [
            {
                text: "本月",
                onClick(picker) {
                    picker.$emit("pick", Vue.utils.simpleDateFormat(new Date(), "m"));
                }
            },
            {
                text: "上月",
                onClick(picker) {
                    const date = new Date(today.getFullYear(), today.getMonth() - 1);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(date, "m"));
                }
            },
            {
                text: "下月",
                onClick(picker) {
                    const last = new Date(today.getFullYear(), today.getMonth() + 1);
                    picker.$emit("pick", Vue.utils.simpleDateFormat(last, "m"));
                }
            },
            {
                text: "一年前",
                onClick(picker) {
                    const date = new Date(today.getFullYear() - 1, today.getMonth());
                    picker.$emit("pick", Vue.utils.simpleDateFormat(date, "m"));
                }
            },
            {
                text: "一年后",
                onClick(picker) {
                    const date = new Date(today.getFullYear() + 1, today.getMonth());
                    picker.$emit("pick", Vue.utils.simpleDateFormat(date, "m"));
                }
            },
            {
                text: "清空",
                onClick(picker) {
                    picker.$emit("pick", "");
                }
            }
        ]
    }

    changeDate(date: string) {
        this.$emit("update:date", date);
        this.$emit("change", date);
    }
}
